import React, { useState, useEffect } from "react";
import axios from "../api/axios";

const CompanyForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    logo: null,
    contact_no: "",
    email: "",
    address: "",
  });

  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch current company info
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await axios.get("/company-info");
        
        if (res.data) {
          setFormData({
            name: res.data.name || "",
            logo: null,
            contact_no: res.data.contact_no || "",
            email: res.data.email || "",
            address: res.data.address || "",
          });
          if (res.data.logo) setPreview(res.data.logo_url);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchCompany();
    
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "logo") {
      const file = e.target.files[0];
      setFormData({ ...formData, logo: file });
      setPreview(URL.createObjectURL(file));
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("contact_no", formData.contact_no);
      form.append("email", formData.email);
      form.append("address", formData.address);
      if (formData.logo) form.append("logo", formData.logo);

      await axios.post("/admin/company-add", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Company info updated successfully!");
    } catch (error) {
      alert(error.response?.data?.message || "❌ Failed to update company info");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Company Info</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <input
                type="text"
                name="contact_no"
                className="form-control"
                value={formData.contact_no}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Address</label>
              <textarea
                name="address"
                className="form-control"
                value={formData.address}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Company Logo</label>
              <input
                type="file"
                name="logo"
                className="form-control-file"
                accept="image/*"
                onChange={handleChange}
              />
              {preview && (
                <div className="mt-2">
                  <p>Preview:</p>
                  <img
                    src={preview}
                    alt="Logo Preview"
                    style={{ maxHeight: "120px", border: "1px solid #ddd" }}
                  />
                </div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-success"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Company Info"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompanyForm;
